export const THEME_STORAGE_KEY = "theme"
export const THEME_CHANGE_EVENT = "theme:change"

function systemPrefersDark() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches
}

function resolveDarkMode(stored) {
  if (stored === "dark") return true
  if (stored === "light") return false
  return systemPrefersDark()
}

export function applyTheme(mode, { persist = true } = {}) {
  const dark = resolveDarkMode(mode)
  document.documentElement.classList.toggle("dark", dark)

  if (persist && mode) {
    window.localStorage.setItem(THEME_STORAGE_KEY, mode)
  }

  window.dispatchEvent(new CustomEvent(THEME_CHANGE_EVENT, { detail: { mode, dark } }))
}

export function currentThemeMode() {
  const stored = window.localStorage.getItem(THEME_STORAGE_KEY)
  if (stored === "dark" || stored === "light") return stored
  return systemPrefersDark() ? "dark" : "light"
}
